import API_CONFIG from '../config/api';
import { apiDelete, apiGet, apiPost } from './api';

const leerJson = async (response) => {
  const data = await response.json();
  if (data && data.success === false) {
    throw new Error(data.error || 'Error inesperado del servidor');
  }
  return data;
};

export const previsualizarRanking = async (url, anio, ambito) => {
  const response = await apiPost(API_CONFIG.ENDPOINTS.RANKINGS.PREVISUALIZAR, { url, anio, ambito });
  return leerJson(response);
};

export const guardarRanking = async (url, anio, ambito, decisiones = []) => {
  const response = await apiPost(API_CONFIG.ENDPOINTS.RANKINGS.GUARDAR, { url, anio, ambito, decisiones });
  return leerJson(response);
};

export const listarRanking = async (anio, tipo) => {
  const params = new URLSearchParams();
  if (anio) params.set('anio', String(anio));
  if (tipo) params.set('tipo', tipo);
  const qs = params.toString();
  const response = await apiGet(`${API_CONFIG.ENDPOINTS.RANKINGS.LISTAR}${qs ? `?${qs}` : ''}`);
  return leerJson(response);
};

export const quitarCargaRanking = async (anio, meetId) => {
  const params = new URLSearchParams({ anio: String(anio), meet_id: meetId });
  const response = await apiDelete(`${API_CONFIG.ENDPOINTS.RANKINGS.QUITAR_CARGA}?${params.toString()}`);
  return leerJson(response);
};
